/**
 * Typed contract for GET /api/v1/public/events/:id/onboarding.
 *
 * Backs the public, shareable onboarding document at /v/:eventId/onboarding.
 * Public + unauthenticated, mirroring loadViewerPayload — fetched with
 * `credentials: 'omit'`.
 */

import { apiUrl } from '@/lib/apiBase'

export interface OnboardingCopy {
  intro: string
  why: string
  how_to_stream: string
  iphone_requirements: string
  activation: string
  testing_intro: string
  testflight_url: string
  app_store_url: string
  discord_url: string
  whatsapp_url: string
}

export interface OnboardingSponsor {
  campaign_id: string
  sponsor_name: string
  campaign_name: string
}

export interface OnboardingCamera {
  name: string
  participant_identity: string
  stream_id: string
  status: string
  sponsor: OnboardingSponsor | null
}

export interface OnboardingEvent {
  id: string
  name: string
  logo_url: string | null
}

export interface OnboardingPayload {
  event: OnboardingEvent
  onboarding: OnboardingCopy
  cameras: OnboardingCamera[]
}

interface OnboardingPayloadResponse {
  data: OnboardingPayload
}

export async function loadOnboardingPayload(eventId: string): Promise<OnboardingPayload> {
  const res = await fetch(apiUrl(`public/events/${encodeURIComponent(eventId)}/onboarding`), {
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  })
  if (!res.ok) {
    throw new Error(`Failed to load onboarding (${res.status})`)
  }
  const body = (await res.json()) as OnboardingPayloadResponse
  return body.data
}
